(function () {
  "use strict";

  // Scroll reveal via IntersectionObserver
  var targets = document.querySelectorAll("[data-reveal]");
  if ("IntersectionObserver" in window && targets.length) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    targets.forEach(function (el) {
      io.observe(el);
    });
  } else {
    targets.forEach(function (el) {
      el.classList.add("is-visible");
    });
  }

  // Toolbar: add scrolled state after some Y offset
  var toolbar = document.querySelector(".pexter-toolbar");
  if (toolbar) {
    var onScroll = function () {
      if (window.scrollY > 12) {
        toolbar.classList.add("is-scrolled");
      } else {
        toolbar.classList.remove("is-scrolled");
      }
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  // Hero hover-video:
  //   - Page load → video plays continuously, looping every 10s (0→10s → restart)
  //   - Hover / tap → product still takes over, video pauses in place
  //   - Mouse leave / tap again → video resumes from where it was
  var HOVER_VIDEO_LOOP = 10; // seconds per loop
  var hoverVideos = document.querySelectorAll("[data-hover-video]");
  hoverVideos.forEach(function (container) {
    var video = container.querySelector("video");
    if (!video) return;

    // We control looping manually (only the first N seconds)
    video.loop = false;

    video.addEventListener("timeupdate", function () {
      if (video.currentTime >= HOVER_VIDEO_LOOP) {
        try { video.currentTime = 0; } catch (e) {}
      }
    });

    var showStill = function () {
      container.classList.add("is-showing-still");
      video.pause();
    };
    var showVideo = function () {
      container.classList.remove("is-showing-still");
      try {
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      } catch (e) {}
    };

    container.addEventListener("mouseenter", showStill);
    container.addEventListener("mouseleave", showVideo);

    container.addEventListener("touchstart", function (e) {
      if (container.classList.contains("is-showing-still")) {
        showVideo();
      } else {
        showStill();
      }
    }, { passive: true });

    // Mobile only: scrolling away from top locks the product still.
    // The video only comes back when the user scrolls all the way back to top.
    var isCoarse =
      window.matchMedia && window.matchMedia("(pointer: coarse)").matches;
    if (isCoarse) {
      window.addEventListener(
        "scroll",
        function () {
          if (window.scrollY <= 2) {
            showVideo();
          } else {
            showStill();
          }
        },
        { passive: true }
      );
    }
  });

  // Mobile: paw-print ripple on tap
  var PAW_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">' +
    '<g fill="#f04812">' +
    '<ellipse cx="16" cy="20" rx="5.5" ry="5"/>' +
    '<ellipse cx="8" cy="13" rx="2.6" ry="3.2"/>' +
    '<ellipse cx="24" cy="13" rx="2.6" ry="3.2"/>' +
    '<ellipse cx="12" cy="7" rx="2.2" ry="2.8"/>' +
    '<ellipse cx="20" cy="7" rx="2.2" ry="2.8"/>' +
    "</g></svg>";

  var spawnPaw = function (x, y) {
    var paw = document.createElement("span");
    paw.className = "pexter-paw-print";
    paw.style.left = x + "px";
    paw.style.top = y + "px";
    // Randomize slight rotation to feel organic
    var rot = (Math.random() * 30 - 15).toFixed(1);
    paw.style.setProperty("--paw-rot", rot + "deg");
    paw.innerHTML = PAW_SVG;
    document.body.appendChild(paw);
    setTimeout(function () {
      if (paw && paw.parentNode) paw.parentNode.removeChild(paw);
    }, 2050);
  };

  // Fire on both mouse clicks (desktop) and touches (mobile) via pointerdown
  if (window.PointerEvent) {
    document.addEventListener(
      "pointerdown",
      function (e) {
        spawnPaw(e.clientX, e.clientY);
      },
      { passive: true }
    );
  } else {
    // Fallback: older browsers without PointerEvent support
    document.addEventListener(
      "click",
      function (e) {
        spawnPaw(e.clientX, e.clientY);
      },
      { passive: true }
    );
    document.addEventListener(
      "touchstart",
      function (e) {
        if (!e.touches || !e.touches.length) return;
        var t = e.touches[0];
        spawnPaw(t.clientX, t.clientY);
      },
      { passive: true }
    );
  }

})();
